import brandStyles from './styles'

const brandConfig = Object.freeze({
  brand: 'vc-sportshub-za-en',
  name: 'Sports Hub',
  baseRoute: '/home',
  styles: brandStyles,
  theme: Object.freeze({
    primaryColor: '#E31E24',
    secondaryColor: '#1A1A1A',
    accentColor: '#FFD100'
  }),
  features: Object.freeze({
    cricket: true,
    rugby: true,
    soccer: true,
    motorsport: true,
    trivia: true,
    news: true,
    fixtures: true,
    liveTV: false
  }),

  productId: 502,
  externalRef: 12335642,
  revenuePartnerId: 33,

  serviceIds: Object.freeze({
    free: 'vc-sportshub-free',
    premium: 'vc-fanclash-sportshubtrivia-daily-01'
  }),

  sportIds: Object.freeze({
    FOOTBALL: 1,
    CRICKET: 3,
    RUGBY: 5,
    MOTORSPORT: 7
  })
})

export default brandConfig
